import { ICustomerDetails } from "@interface/customerDetails/ICustomerDetails";
import { IContactDetailsResponse } from "../interfaces/responses/IEirSalesContactDetailsResponse";
import { capitalizeWord } from "@utils/addressFormatter";

export const mapEirSalesContactDetails = (response: IContactDetailsResponse): ICustomerDetails => ({
    billingAddress: {
        addressLine1: capitalizeWord(response.billingAddress.addressLine1),
        addressLine2: response.billingAddress.addressLine2 ? capitalizeWord(response.billingAddress.addressLine2) : "",
        addressLine3: response.billingAddress.addressLine3 ? capitalizeWord(response.billingAddress.addressLine3) : "",
        county: response.billingAddress.county ?? "",
        eircode: response.billingAddress.eircode ?? "",
        town: response.billingAddress.town ? capitalizeWord(response.billingAddress.town) : "",
    },
    contactPermission: {
        permissionGroups: response.permissionGroups.map((permissionGroup) => ({
            name: permissionGroup.name,
            permissionGroup: permissionGroup.permissionGroup,
            permissions: permissionGroup.permissions.map((permission) => ({
                enabled: permission.enabled,
                name: permission.name,
                permission: permission.permission,
            })),
        })),
    },
    deliveryAddress: {
        addressLine1: response.deliveryAddress?.addressLine1
            ? capitalizeWord(response.deliveryAddress.addressLine1)
            : "",
        addressLine2: response.deliveryAddress?.addressLine2
            ? capitalizeWord(response.deliveryAddress.addressLine2)
            : "",
        addressLine3: response.deliveryAddress?.addressLine3
            ? capitalizeWord(response.deliveryAddress.addressLine3)
            : "",
        county: response.deliveryAddress?.county ?? "",
        eircode: response.deliveryAddress?.eircode ?? "",
        town: response.deliveryAddress?.town ? capitalizeWord(response.deliveryAddress.town) : "",
    },
    firstName: response.firstName,
    lastName: response.lastName,
    birthDate: response.birthDate,
    email: response.email,
    mobileNumber: response.phoneNumber ?? "",
});
